require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-mitchell-truwit.json") })
        }
      }, "path---insights-mitchell-truwit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-mitchell-truwit!./.cache/json/insights-mitchell-truwit.json
// module id = 1119
// module chunks = 231608221292675